import React from "react";
import { crmDefs, crmRecordDefs, dynamicsEntityDefs } from "../types";

export interface CreateCrmRecordValue {
  crmType: string;
  recordType: string;
}

interface Props {
  updateValue: (value: CreateCrmRecordValue) => void;
  value: CreateCrmRecordValue;
}

export default function CreateCrmRecordRuleForm({ value, updateValue }: Props) {
  const crmType = value?.crmType || "netsuite";

  const recordOptions = crmType === "dynamics365"
    ? Object.keys(dynamicsEntityDefs)
    : Object.keys(crmRecordDefs);

  function handleCrmChange(newCrmType: string) {
    // Reset record type when CRM changes so we never have a stale NetSuite type selected for Dynamics
    updateValue({ crmType: newCrmType, recordType: "" });
  }

  return (
    <>
      <div className="flex items-center gap-2">
        <span className="text-sm text-slate-600">CRM</span>
        <select
          className="flex flex-row input overflow-ellipsis whitespace-nowrap w-48 ml-2"
          value={crmType}
          onChange={(e) => handleCrmChange(e.currentTarget.value)}
        >
          <option value="netsuite">NetSuite</option>
          <option value="dynamics365">Microsoft Dynamics 365</option>
        </select>
      </div>

      <div className="flex items-center gap-2 mt-2">
        <span className="text-sm text-slate-600">Record type</span>
        <select
          className="flex flex-row input overflow-ellipsis whitespace-nowrap w-64 ml-2"
          value={value?.recordType || ""}
          onChange={(e) =>
            updateValue({ ...value, crmType, recordType: e.currentTarget.value })
          }
        >
          <option value="">— select a record type —</option>
          {recordOptions.map((c, i) => (
            <option key={i} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>
    </>
  );
}
